@if (!loaded()) {
    <div class="loading">
        <kui-loader class="centered d-flex flex-stretch justify-content-center align-items-center"></kui-loader>
    </div>
}

@if (status()) {
    <div class="error">
        <div class="m-4 centered d-flex flex-stretch justify-content-center align-items-center">
            <div class="m-4">
                <div>
                    <h4 class="text-center">{{ 'MEDIA.STATUS.TITLE.' + status().status.toUpperCase() | translate }}</h4>
                </div>
                <div class="text-center mb-2 muted-less">{{ 'MEDIA.STATUS.DESCRIPTION.' + status().status.toUpperCase() | translate: { user: changedByUser } }}</div>
                
                @if (status().progress > 0) {
                    <kui-progress
                        [value]="status().progress"
                        type="primary"></kui-progress>
                }
                
                @if (requesterName) {
                    <div class="small text-center mt-2 muted-less">{{ 'MEDIA.STATUS.QUEUED_BY' | translate: { requester: requesterName, date: requesterDate, type: requesterType } }}</div>
                }
            </div>
        </div>
    </div>
}

@if (error()) {
    <div class="error">
        <div class="centered d-flex flex-stretch justify-content-center align-items-center">
            <kui-alert type="none"
                class="key-alert-wrapper">
                <kui-icon name="ban"
                    size="lg"></kui-icon>
                <span>{{ error() }}</span>
            </kui-alert>
        </div>
    </div>
}

<div class="videoContainer">
    <video class="video"
        [class.cover]="cover"
        [class.hidden]="!loaded() || error() || status()"
        autoplay
        playsinline>
        <source [src]="video.url" [type]="video.type" />
    </video>
</div>
@if (loaded() && !error() && !status() && download) {
    <a kui-button
        class="download"
        target="_blank"
        [download]="video.filename"
        [href]="video.url">
        <kui-icon name="download"></kui-icon>
    </a>
}